import { useState } from "react";
import type { DocumentSnapshot } from "firebase/firestore";

export enum QueryParamsStatus {
  FIND_BY_PROVINCE = "findByProvince",
  FIND_BY_DISTRICT = "findByDistrict",
  FIND_BY_MUNICIPALITY = "findByMunicipality",
  FIND_BY_WARD = "findByWard",
  FIND_BY_JOB_TYPE = "findByJobType",
  FIND_BY_GENDER = "findByGender",
  IS_AVAILABLE = "isAvailable",
  SEARCH_BY = "searchBy",
  PAGE = "page",
  PAGE_SIZE = "pageSize",
}

export interface QueryParamsConfig {
  recruiterId?: string | null;
  jobId?: string | null;
  findByProvince?: string | null;
  findByDistrict?: string | null;
  findByMunicipality?: string | null;
  findByWard?: string | null;
  findByJobType?: string | null;
  findByGender?: string | null;
  isAvailable?: boolean | null;
  searchBy?: string | null;
  page?: number;
  pageSize?: number;
  cursor?: DocumentSnapshot | null;
}

// Extend initial state to include a map of DocumentSnapshots by page
export const initialState: QueryParamsConfig & {
  cursorMap: Record<number, DocumentSnapshot | null>;
} = {
  recruiterId: null,
  jobId: null,
  findByProvince: null,
  findByDistrict: null,
  findByMunicipality: null,
  findByWard: null,
  findByJobType: null,
  findByGender: null,
  isAvailable: null,
  searchBy: null,
  page: 1,
  pageSize: 10,
  cursor: null,
  cursorMap: { 1: null },
};

const useFilterPagination = () => {
  const [state, setState] = useState(initialState);

  // on page/button change: update page, pageSize, and load cursor for that page
  const onTableChange = (page: number, pageSize: number) => {
    const nextCursor = state.cursorMap[page - 1] ?? null;
    setState({
      ...state,
      page,
      pageSize,
      cursor: nextCursor,
    });
  };

  // record the DocumentSnapshot to use as cursor for a given page
  const setPageCursor = (page: number, snapshot: DocumentSnapshot | null) => {
    setState((prev) => ({
      ...prev,
      cursorMap: {
        ...prev.cursorMap,
        [page]: snapshot,
      },
    }));
  };

  const onSearch = (value: string, key: QueryParamsStatus) => {
    setState({
      ...state,
      [key]: value,
      page: 1,
      cursor: null,
      cursorMap: { 1: null },
    });
  };

  const onFilterChange = (value: string, key: QueryParamsStatus) => {
    setState({
      ...state,
      [key]: value,
      page: 1,
      cursor: null,
      cursorMap: { 1: null },
    });
  };

  return {
    queryParamaters: state as QueryParamsConfig,
    setQueryParameters: setState,
    onSearch,
    onFilterChange,
    onTableChange,
    setPageCursor,
  };
};

export { useFilterPagination };
